// // src/components/SocketClient.js
// import React, { useEffect, useRef } from 'react';
// import { io } from 'socket.io-client';

// export const smileySocket = io(process.env.REACT_APP_SMILEY_BASE_URL);
// export const onlineUsersSocket = io(process.env.REACT_APP_ONLINE_USERS_BASE_URL);
// const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'http://localhost:5000';

// const SocketClient = () => {
//   const socketRef = useRef(null);

//   useEffect(() => {
//     // Connexion au serveur socket.io
//     socketRef.current = io(SOCKET_URL, {
//       withCredentials: true,
//     });

//     socketRef.current.on('connect', () => {
//     });

//     socketRef.current.on('win', (data) => {
//     });

//     return () => {
//       socketRef.current.disconnect();
//     };
//   }, []);

//   return (
//     <div>
//       <h2>Socket.IO React Client</h2>
//     </div>
//   );
// };

// export default SocketClient;

// src/engine/socket.js
// import { io } from 'socket.io-client';

// const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'http://localhost:5000';

// export const socket = io(SOCKET_URL, {
//     autoConnect: true,
//     transports: ["websocket", "polling"],
// });

// // ✅ Dès la connexion, émettre automatiquement si userId existe
// socket.on('connect', () => {
//     const userId = sessionStorage.getItem('userId');
//     const username = sessionStorage.getItem('userName');
//     if (userId) {
//         socket.emit('user_connected', {
//             userId: parseInt(userId),
//             username,
//         });
//     }
// });

// export const onlineUsersSocket = socket;
// export const smileySocket = process.env.REACT_APP_SMILEY_BASE_URL
//     ? io(process.env.REACT_APP_SMILEY_BASE_URL)
//     : socket;

import { io } from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'http://localhost:5000';

export const socket = io(SOCKET_URL, {
    autoConnect: true, // ✅ Connexion automatique au chargement
    reconnection: true, // ✅ Reconnexion automatique en cas de coupure
    transports: ["websocket", "polling"],
});

export const onlineUsersSocket = socket;
export const smileySocket = process.env.REACT_APP_SMILEY_BASE_URL
    ? io(process.env.REACT_APP_SMILEY_BASE_URL)
    : socket;
